import { PAGE_VIEWED, TRACK_ADD_BANNER_CLICKED_EVENT, TRACK_BANNER_CONTENT_SELECTED_EVENT, TRACK_BANNER_CROPPED_EVENT, TRACK_BANNER_FILTERED_EVENT, TRACK_BANNER_LIST_SCREEN_VIEW, TRACK_CROP_BANNER_CLICKED_EVENT, TRACK_FILTER_BANNER_CLICKED_EVENT } from "src/constants/adoption/eventTypes";
import { useTrackEventForAdoption } from "src/query/adoption";
import { SettingsModule } from "src/types/settings/common";
import _ from "lodash";
import { AddBannerClicked, BannerContentSelected, BannerCropped, BannerFiltered, CropBannerClicked, FilterBannerClicked } from "src/types/adoption/settings/viewerSettings";

export const useViewerSettingsBannerAdoption = () => {
  const { mutate: trackEvent } = useTrackEventForAdoption(SettingsModule.VIEWER_SETTINGS);

  const trackCropBannerClicked = ({ sourceCta }: CropBannerClicked) => { 
    trackEvent({
      event: TRACK_CROP_BANNER_CLICKED_EVENT,
      properties: {
        banner_type: "Image",
        source_cta: sourceCta || "",
      },
    });
  };

  const trackAddBannerClicked = ({ sourceCta }: AddBannerClicked) => {
    trackEvent({
      event: TRACK_ADD_BANNER_CLICKED_EVENT,
      properties: {
        source_cta: sourceCta,
      },
    });
  };

  const trackFilterBannerClicked = ({ bannerType, cta }: FilterBannerClicked) => {
    trackEvent({
      event: TRACK_FILTER_BANNER_CLICKED_EVENT,
      properties: {
        banner_type: _.capitalize(bannerType),
        cta: cta || "",
      },
    });
  };

  const trackBannerFilteredEvent = ({ bannerType, cta }: BannerFiltered) => {
    trackEvent({
      event: TRACK_BANNER_FILTERED_EVENT,
      properties: {
        banner_type: _.capitalize(bannerType),
        cta: cta || "",
      },
    });
  };

  const trackBannerContentSelected = ({ bannerType, sourceCta }: BannerContentSelected) => {
    trackEvent({
      event: TRACK_BANNER_CONTENT_SELECTED_EVENT,
      properties: {
        banner_type: _.capitalize(bannerType),
        source_cta: sourceCta || "",
      },
    });
  };

  const trackBannerCropped = ({ collectionName, sourceCta }: BannerCropped) => {
    trackEvent({
      event: TRACK_BANNER_CROPPED_EVENT,
      properties: {
        collection_name: collectionName || "",
        banner_type: "Image",
        source_cta: sourceCta || "",
      },
    });
  };

  const trackPageViewed = () => {
    trackEvent({
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_BANNER_LIST_SCREEN_VIEW,
      },
    });
  }

  return {
    trackCropBannerClicked,
    trackBannerCropped,
    trackAddBannerClicked,
    trackPageViewed,
    trackBannerContentSelected,
    trackFilterBannerClicked,
    trackBannerFilteredEvent,
  };
};
